import type { FormValues } from "../types/FormValues";
import type { FormattedErrors } from "../context/utils/formatZodErrors";
import type { TouchedValues } from "../context/ContestManageContext";

const getFlattenValuesForEventReports = (
  values: FormValues | FormattedErrors | TouchedValues,
  pathPrefix = []
): Record<string, unknown> => Object.entries(values ?? {}).reduce((acc, [key, value]) => {
    if (value != null && typeof value === 'object' && !Array.isArray(value)) {
      return {
        ...acc,
        ...getFlattenValuesForEventReports(value, [...pathPrefix, key]),
      };
    }
    return {
      ...acc,
      [`${[...pathPrefix, key].join('.')}`]: value,
    };
  }, {});

export default getFlattenValuesForEventReports;
